import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Conditions from "@/pages/Conditions";
import ConditionDetail from "@/pages/ConditionDetail";
import Treatments from "@/pages/Treatments";
import TreatmentDetail from "@/pages/TreatmentDetail";
import Education from "@/pages/Education";
import ArticleDetail from "@/pages/ArticleDetail";
import Research from "@/pages/Research";
import Appointment from "@/pages/Appointment";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import ArticleEditor from "@/pages/admin/ArticleEditor";

function SmoothScroll() {
    useEffect(() => {
        const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReduced) return;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); lenis.destroy(); };
    }, []);
    return null;
}

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
}

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <Toaster position="top-center" richColors />
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/conditions" element={<Conditions />} />
                        <Route path="/conditions/:slug" element={<ConditionDetail />} />
                        <Route path="/treatments" element={<Treatments />} />
                        <Route path="/treatments/:slug" element={<TreatmentDetail />} />
                        <Route path="/patient-education" element={<Education />} />
                        <Route path="/patient-education/:slug" element={<ArticleDetail />} />
                        <Route path="/research" element={<Research />} />
                        <Route path="/appointment" element={<Appointment />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy-policy" element={<Legal page="privacy" />} />
                        <Route path="/terms-of-use" element={<Legal page="terms" />} />
                        <Route path="/medical-disclaimer" element={<Legal page="disclaimer" />} />
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />
                        <Route path="/admin/articles/new" element={<ArticleEditor />} />
                        <Route path="/admin/articles/:slug" element={<ArticleEditor />} />
                        <Route path="*" element={<Home />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
